class CMRecentlyViewed {
  constructor() {
    this.stock_limit = 10;
    this.storage_key = 'recently_viewed';
    this.containers = document.querySelectorAll('.cm-recently-viewed__inner');
    this.initRecentlyViewed();
    if(location.pathname.includes('/products/')) {
      this.addProduct(location.pathname.split('/').pop());
    }
  }

  initRecentlyViewed() {
    if (!this.containers.length) return;
    this.containers.forEach(async container => {
      const maxProducts = Number(container.dataset.maxProducts) || 4;
      const recently_viewed_data = this.getProducts();
      let recently_viewed_products = '';
      for(let i in recently_viewed_data) {
        if(i >= maxProducts) {
            break;
        }
        const product_data = await fetch(`/products/${recently_viewed_data[i]}?view=card`);
        const product_data_text = await product_data.text();
        recently_viewed_products += product_data_text;
      }
      container.innerHTML = recently_viewed_products;
      if(recently_viewed_data.length == 0) {
        container.closest('.shopify-section.cm-recently-viewed').style.display = 'none';
      } else {
        new Splide(container.closest('.splide')).mount();
      }
    });
  }

  addProduct(productId) {
    let recently_viewed = this.getProducts();
    recently_viewed = recently_viewed.filter((id) => id !== productId);
    recently_viewed.unshift(productId);
    recently_viewed = recently_viewed.slice(0, this.stock_limit);
    localStorage.setItem(this.storage_key, JSON.stringify(recently_viewed));
  }

  clearProducts() {
    localStorage.removeItem(this.storage_key);
  }

  getProducts() {
    return JSON.parse(localStorage.getItem(this.storage_key) || '[]');
  }
}
document.addEventListener('DOMContentLoaded', () => {
    new CMRecentlyViewed();
});